import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import './languageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, setLanguage, t } = useTranslation();

  return (
    <div className="language-switcher">
      <button 
        onClick={() => setLanguage('fr')}
        className={language === 'fr' ? 'active' : ''}
      >
        {"Français"}
      </button>
      <button 
        onClick={() => setLanguage('en')}
        className={language === 'en' ? 'active' : ''}
      >
        {"English"}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
